$('[data-fancybox]').fancybox({
    youtube: {
        controls: 0,
        showinfo: 0
    },
    vimeo: {
        color: 'f00'
    },
    iframe: {
        css: {
            width: '600px'
        }
    }
});

$(document).click(function (e) {
    var target = $(e.target);
    if (target.hasClass('mobile-nav-wrapper') || target.hasClass('js-mobile-nav-toggle') || target.hasClass('icon') || target.hasClass('icon__fallback-text') || target.hasClass('fa') || target.closest('.mobile-nav-wrapper').length > 0) {

    } else {
        theme.MobileNav.closeMobileNav();
    }
});

/* FUNCTIONS */
/* support tabs */
function deactiveAllSupportTab() {
    jQuery('.support-tabs .nav-tabs:first() li').removeClass('active');
    jQuery('.support-tabs .nav-tabs:first() a').attr('aria-expanded', 'false');
    jQuery('.support-tabs .tab-content:first() > .tab-pane').removeClass('active in');
}

function activeSupportTab(tabId) {
    deactiveAllSupportTab();
    jQuery('.support-tabs .nav-tabs:first() a[href="#'+ tabId +'"]').parent().addClass('active');
    jQuery('.support-tabs .nav-tabs:first() a[href="#'+ tabId +'"]').attr('aria-expanded', 'true');
    jQuery('.support-tabs .tab-content:first() > .tab-pane#'+ tabId +'').addClass('active in');
}

